<!-- <button mat-menu-item (click)="validateMe()"><span>Validate</span></button> -->
<router-outlet></router-outlet>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>